import { NotificationStatus } from '@cp-shared-19/frontend-ui';
import { Notification } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ContactDetailsCheckPendingNotification: React.FC = () => {
    const { t } = useTranslation('my-profile-cms');

    return (
        <Notification
            className={'u-mb'}
            testId="documents-error"
            status={NotificationStatus.success}
            title={''}
            hideTitle={true}
            visible
            showCloseButton={false}
        >
            <div dangerouslySetInnerHTML={{ __html: t('notifications.contact-information-change-pending') }}></div>
        </Notification>
    );
};
